export default function diffArrays(a1: any[], a2: any[]) {
	return a1.filter((i: any) => a2.includes(i)).concat(a2.filter((i: any) => a1.includes(i)));
}
